/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Section_OptionalInputs */



/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Ad_Section_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_section_optional = /** @type {((inputs?: Ad_Section_OptionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Section_OptionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Facultatif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzionale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Необязательный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opcional")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选修的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वैकल्पिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opcional")
	return /** @type {LocalizedString} */ ("Optional")
});